import React, { useEffect, useRef } from "react";

import { Alert, Button } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";

/**
 * MessageContainerModal Component
 * 
 * Floating alert modal containing a dismissible message. Closes automatically when
 * user clicks outside the alert area. Manages click detection using outside-click hook
 * and ref to container element.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.props - Prop object containing:
 *   - alert: boolean showing/hiding alert
 *   - closeAlert: callback to dismiss alert
 *   - message: content to display in alert
 * @returns {JSX.Element} Floating dismissible alert container
 */
const MessageContainerModal = ({ props }) => {
  const { alert, closeAlert, message } = props;

  const closeModal = () => closeAlert();

  const ref = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!ref.current.contains(e.target)) {
        closeModal();
      }
    };
    if (alert) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [alert]);

  return (
    <div ref={ref}>
      {alert && (
        <Alert className="error-message floating-alert" variant="light">
          <div>
            <div style={{ textAlign: "right" }}>
              <Button className="pitchdeckmessageclose" onClick={closeAlert}>
                <IoMdClose />
              </Button>
            </div>
            {message}
          </div>
        </Alert>
      )}
    </div>
  );
};

export default MessageContainerModal;
